import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import * as yup from "yup";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {useAuth} from "hooks/useAuth";
import {useServerErrors} from "hooks/useServerErrors";
import GenericButton from "shared/ui/GenericButton";
import PageTitle from "shared/ui/PageTitle";
import FormLabelBox from "shared/ui/FormLabelBox";
import FormFieldBox from "shared/ui/FormFieldBox";
import FormField from "shared/form/FormField";
import CustomButton from "shared/ui/CustomButton";
import ErrorsList from "shared/ui/ErrorsList";
import BoxContent from "shared/ui/BoxContent";
import {APIPostTag} from "../api/testTags";

interface IFormStudentEdit {
    name: string;
}

const schema = yup
    .object({})
    .required();

const TestTag = () => {
    const { update } = useAuth();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<string>("");

    const methods = useForm<IFormStudentEdit>({
        resolver: yupResolver(schema),
    });
    const { handleServerErrors } = useServerErrors<IFormStudentEdit>(methods.setError);

    const handleErrors = (err: any) => {
        if (err?.response?.status === 400) {
            let errors = err.response.data.data;
            handleServerErrors(errors);
        } else {
            update("error", {show: true, code: "A001"});
        }
    };

    const onSubmit: SubmitHandler<IFormStudentEdit> = (data) => {
        methods.clearErrors();
        setErrorMessage("");

        update("loading", { show: true, modal: true });
        APIPostTag({name: data.name})
            .then((response) => {
                if (response.data.success) {
                    navigate(`/taguri/taguri-adaugate`, { replace: true });
                } else {
                    update("error", { show: true, code: "A002" });
                }
            })
            .catch(handleErrors)
            .finally(() => update("loading", { show: false }));
    }

    return (
        <>
            <PageTitle
                back={true}
                actions={<GenericButton type="close" onClick={() => navigate(-1)} />}
            >
             Adaugă tag
            </PageTitle>

            <BoxContent>
                <Box width="100%">
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
                            <Grid container spacing={1.5} alignItems="center">
                                <FormLabelBox title="Nume:" />
                                <FormFieldBox>
                                        <FormField
                                            error={!!methods.formState.errors.name?.message}
                                            name="name"
                                            type="text"
                                            label="Nume"
                                            autoFocus={true}
                                            errorMessage={methods.formState.errors.name?.message}
                                        />
                                </FormFieldBox>

                                <FormLabelBox />
                                <FormFieldBox>
                                    <CustomButton submit buttonType="textIcon" bgcolor="dark">ADAUGĂ TAG</CustomButton>
                                    <ErrorsList show={errorMessage !== ""}>{errorMessage}</ErrorsList>
                                </FormFieldBox>
                            </Grid>
                        </form>
                    </FormProvider>
                </Box>
            </BoxContent>
        </>
    )
}

export default TestTag;